import { isNullOrUndefined } from '@uzurv/core';
import { Location, RideRequestLocation } from '../models';
import { IGeoCoords } from '../services/maps';

export class LocationUtil {
  static addressDisplayRegex: RegExp = /((?:[0-9]+[ ]{1})?[A-Za-z0-9.#\-' ]+),[ ]?([A-Za-z0-9. ]+),[ ]?([A-Z]{2})[,]?[ ]?([0-9]{5})/;

  /**
   * Takes a Location and returns a RideRequestLocation
   *
   * @param location
   */
  static mapLocationToRideRequestLocation(location: Location, offsetCoords?: IGeoCoords): RideRequestLocation {
    if (isNullOrUndefined(location)) {
      return null;
    }

    const rideRequestLocation = new RideRequestLocation();
    rideRequestLocation.locationId = location.id;
    rideRequestLocation.display = location.display;
    rideRequestLocation.latitude = location.latitude;
    rideRequestLocation.longitude = location.longitude;

    // TODO (phill2mj): don't do sublocations like this. instead this method should consume a location and optional sublocation
    if (location.sublocations && location.sublocations[0]) {
      rideRequestLocation.sublocationId = location.sublocations[0].id;
      rideRequestLocation.sublocationName = location.sublocations[0].name;
      rideRequestLocation.sublocationDescription = location.sublocations[0].description;
      rideRequestLocation.latitude = location.sublocations[0].latitude;
      rideRequestLocation.longitude = location.sublocations[0].longitude;
    }
    if (offsetCoords) {
      rideRequestLocation.requiresReview = true;
      rideRequestLocation.latitude = +offsetCoords.lat.toFixed(6);
      rideRequestLocation.longitude = +offsetCoords.lng.toFixed(6);
      rideRequestLocation.sublocationId = null;
      rideRequestLocation.sublocationName = null;
      rideRequestLocation.sublocationDescription = null;
    }
    return rideRequestLocation;
  }

  static maskAddress(addressString: string): string {
    if (isNullOrUndefined(addressString)) {
      return null;
    }

    const firstWhitespaceIndex: number = addressString.indexOf(' ');
    const streetNumber = addressString.substring(0, firstWhitespaceIndex);

    // Return entire address string if there is no street number designation.
    const isNumbersOnly = /^\d+$/.test(streetNumber);
    if (!isNumbersOnly) {
      return addressString;
    }

    let maskedAddress = streetNumber;
    const remainingAddress = addressString.substring(firstWhitespaceIndex, addressString.length);

    if (streetNumber.length > 2) {
      maskedAddress = maskedAddress.substring(0, maskedAddress.length - 2);
      maskedAddress = maskedAddress + '**';
      return maskedAddress + remainingAddress;
    } else if (streetNumber.length === 2) {
      return '**' + remainingAddress;
    } else {
      return '*' + remainingAddress;
    }
  }

  static getStreetAddressFromDisplay(display: string): string {
    if (isNullOrUndefined(display)) {
      return null;
    }

    const match = display.match(LocationUtil.addressDisplayRegex);

    if (isNullOrUndefined(match)) {
      return display;
    }

    return match[1].trim();
  }

  static getCityStateFromDisplay(display: string): string {
    if (isNullOrUndefined(display)) {
      return null;
    }

    const match = display.match(LocationUtil.addressDisplayRegex);

    if (isNullOrUndefined(match)) {
      return display;
    }

    return `${match[2]}, ${match[3]}`;
  }

  static getCityStateZipFromDisplay(display: string): string {
    if (isNullOrUndefined(display)) {
      return null;
    }

    const match = display.match(LocationUtil.addressDisplayRegex);

    if (isNullOrUndefined(match)) {
      return display;
    }

    return `${match[2]}, ${match[3]} ${match[4]}`;
  }

  static getStreetAddressCityStateZipFromDisplay(display: string): string {
    if (isNullOrUndefined(display)) {
      return null;
    }

    const match = display.match(LocationUtil.addressDisplayRegex);

    if (isNullOrUndefined(match)) {
      return display;
    }

    return `${match[1]}, ${match[2]}, ${match[3]} ${match[4]}`;
  }
}
